// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_fl-0";
export var actionModalContentContainer = "_fl-1";
export var createTagButton = "_fl-2";
export var footerContainer = "_fl-7";
export var fullWidthDivider = "_fl-3";
export var hasCreateTagButton = "_fl-4";
export var noCreateTagButton = "_fl-5";
export var tagsContainer = "_fl-6";
export var tagsModalContentContainer = "_fl-8";